import { ListClientBudget } from "Dtos/IBudget";
import { ScheduleInfo, TableItem } from "./TableItem";

const columns = [
  {
    title: "Orçamento",
    key: "budgetId",
  },
  {
    title: "Cliente",
    key: "client",
  },
  {
    title: "Data/horário",
    key: "dataAg",
  },
  {
    title: "Documento",
    key: "document",
  },
  {
    title: "Parceiro",
    key: "covenant",
  },
  {
    title: "Total (R$)",
    key: "total",
  },
  {
    title: "Status",
    key: "status",
  },
  {
    title: "Ações",
    key: "actions",
    className: "text-center",
  },
];

export interface ListBudgetProps {
  data: ListClientBudget[];
  setScheduleInfo: (params: ScheduleInfo) => void;
}

export const ListBudgets = ({ data, setScheduleInfo }: ListBudgetProps) => {
  return (
    <table className="table-content small-separate details">
      <thead>
        <tr>
          {columns.map((columnsItem) => (
            <th
              key={columnsItem.key}
              className={columnsItem.className}
              style={{ color: "#333" }}
            >
              {columnsItem.title}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((item) => (
          <TableItem
            key={item.id}
            listBudget={item}
            setScheduleInfo={setScheduleInfo}
          />
        ))}
      </tbody>
    </table>
  );
};
